import React from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as BigMagnifierIcon } from "common-assets/assets/icons/empty-filters.svg";
import { useIsMobile } from "../utils/useIsMobile";
import { Icon } from "../Icon/Icon";
import { Card } from "../Card/Card";
import { Button } from "../Button/Button";
import { Typography } from "../Typography/Typography";

import useStyles from "./EmptyFiltersCard.style";

interface EmptyFiltersInfoCardProps {
  title?: string;
  description?: string;
  buttonText?: string;
  onClick: () => void;
  buttonType?: "primary" | "secondary" | "tertiary";
  buttonAutoTestId?: string;
  customIcon?: React.ReactNode;
}

export const EmptyFiltersCard: React.FC<EmptyFiltersInfoCardProps> = ({
  title,
  description,
  buttonText,
  onClick,
  buttonType = "primary",
  buttonAutoTestId,
  customIcon
}) => {
  const c = useStyles({});
  const [t] = useTranslation("components");
  const isMobile = useIsMobile();
  const textAlign = isMobile ? "center" : "left";
  return (
    <Card
      className={c.root}
      testId="EmptyFiltersCard"
      size="big"
      type={isMobile ? "ghost" : "base"}
    >
      <Icon>
        {customIcon || <BigMagnifierIcon />}
      </Icon>
      <Typography
        variant={isMobile ? "subHeadline2" : "caption"}
        align={textAlign}
        component="h3"
        className={c.title}
        fontWeight="extraBold"
      >
        {title || t("filters.fund-list.no-results")}
      </Typography>
      <Typography
        className={c.description}
        align={textAlign}
      >
        {description || t("filters.fund-list.no-results-description")}
      </Typography>
      <Button
        buttonVariant="large"
        accent={true}
        onClick={onClick}
        buttonType={buttonType}
        autoTestId={buttonAutoTestId}
      >
        {buttonText || t("filters.fund-list.clear-filter")}
      </Button>
    </Card>
  );
};
